export const getStatusColor = (status) => {
  switch(status?.toLowerCase()) {
    case "pending": return "bg-yellow-100 text-yellow-700";
    case "completed": return "bg-green-100 text-green-700";
    case "cancelled": return "bg-red-100 text-red-700";
    default: return "bg-gray-100 text-gray-700";
  }
};

export const capitalizeStatus = (status) => {
  if (!status) return "";
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
}

export const formatServiceType = (type) => {
switch (type) {
    case "DRYCLEANING" :
      return "Dry Cleaning";
    case "TAILORING":
      return "Tailoring";
    case "WASH_N_FOLD":
      return "Wash & Fold";
    default:
      return type;
  }
}
